import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:5125';

export const addContact = (data) => axios.post(`${API_BASE_URL}/contacts`, data);
